import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { ROUTES } from '../constants/routes';
import { shouldHoldSite } from './holding';

// Public pages
import Home from '../pages/Home';
import Tests from '../pages/Tests';
import TestDetail from '../pages/TestDetail';
import Packages from '../pages/Packages';
import PackageDetail from '../pages/PackageDetail';
import Specials from '../pages/Specials';
import Membership from '../pages/Membership';
import About from '../pages/About';
import Blog from '../pages/Blog';
import FAQ from '../pages/FAQ';
import Support from '../pages/Support';
import Centres from '../pages/Centres';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Careers from '../pages/Careers';
import Corporate from '../pages/Corporate';
import OurDoctors from '../pages/OurDoctors';
import Cart from '../pages/Cart';
import Booking from '../pages/Booking';
import CancelBooking from '../pages/CancelBooking';
import Track from '../pages/Track';
import AppRedirect from '../pages/AppRedirect';
import ComingSoon from '../pages/ComingSoon';

// Auth + user
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import Reports from '../pages/Reports';
import MyTickets from '../pages/MyTickets';
import Dashboard from '../pages/Dashboard';

// Portals
import MedicalDashboard from '../pages/portals/MedicalDashboard';
import LabDashboard from '../pages/portals/LabDashboard';
import CorporateDashboard from '../pages/portals/CorporateDashboard';
import QAPortal from '../pages/portals/QAPortal';
import AdminPortal from '../pages/portals/AdminPortal';
import SiteAdmin from '../pages/portals/SiteAdmin';

const AppRoutes = () => {
  // Read once per mount: the flag is baked in at build time and the
  // preview token is resolved on first load, so it cannot change
  // between one route and the next.
  const held = shouldHoldSite();

  // Holding mode. Only the routes below survive — staff sign-in, the six
  // portals, and the two URLs the mobile app and the printed QR codes
  // depend on. Everything else, the fallback included, becomes the
  // holding page, so there is no path back into the shop.
  if (held) {
    return (
      <Routes>
        <Route path={ROUTES.LOGIN} element={<Login />} />
        <Route path={ROUTES.APP_PRIVACY} element={<PrivacyPolicy />} />
        <Route path={ROUTES.APP_DOWNLOAD} element={<AppRedirect />} />

        <Route path={ROUTES.MED_DASHBOARD} element={<MedicalDashboard />} />
        <Route path={ROUTES.LAB_DASHBOARD} element={<LabDashboard />} />
        <Route path={ROUTES.CORP_DASHBOARD} element={<CorporateDashboard />} />
        <Route path={ROUTES.QA_PORTAL} element={<QAPortal />} />
        <Route path={ROUTES.ADMIN} element={<AdminPortal />} />
        <Route path={ROUTES.SITE_ADMIN} element={<SiteAdmin />} />

        <Route path="*" element={<ComingSoon />} />
      </Routes>
    );
  }

  return (
  <Routes>
    {/* Pages with main layout (navbar + footer) */}
    <Route element={<MainLayout />}>
      <Route path={ROUTES.HOME} element={<Home />} />
      <Route path={ROUTES.TESTS} element={<Tests />} />
      <Route path={ROUTES.TEST_DETAIL} element={<TestDetail />} />
      <Route path={ROUTES.PACKAGES} element={<Packages />} />
      <Route path={ROUTES.PACKAGE_DETAIL} element={<PackageDetail />} />
      <Route path={ROUTES.SPECIALS} element={<Specials />} />
      <Route path={ROUTES.MEMBERSHIP} element={<Membership />} />
      <Route path={ROUTES.ABOUT} element={<About />} />
      <Route path={ROUTES.BLOG} element={<Blog />} />
      <Route path={ROUTES.BLOG_ARTICLE} element={<Blog />} />
      <Route path={ROUTES.FAQ} element={<FAQ />} />
      <Route path={ROUTES.SUPPORT} element={<Support />} />
      <Route path={ROUTES.CENTRES} element={<Centres />} />
      <Route path={ROUTES.PRIVACY} element={<PrivacyPolicy />} />
      <Route path={ROUTES.CAREERS} element={<Careers />} />
      <Route path={ROUTES.CORPORATE} element={<Corporate />} />
      <Route path={ROUTES.DOCTORS} element={<OurDoctors />} />
      <Route path={ROUTES.CART} element={<Cart />} />
      <Route path={ROUTES.BOOKING} element={<Booking />} />
      <Route path={ROUTES.CANCEL_BOOKING} element={<CancelBooking />} />
      <Route path={ROUTES.TRACK} element={<Track />} />
      <Route path={ROUTES.REPORTS} element={<Reports />} />
      <Route path={ROUTES.MY_TICKETS} element={<MyTickets />} />
      <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
    </Route>

    {/* Login / Signup (no shell) */}
    <Route path={ROUTES.LOGIN} element={<Login />} />
    <Route path={ROUTES.SIGNUP} element={<Signup />} />

    {/* Bare privacy policy — no navbar / footer. Submitted as the
        Play Store + App Store privacy URL for the mobile app. Same
        page component as the public /privacy route; the difference
        is just the missing MainLayout chrome. */}
    <Route path={ROUTES.APP_PRIVACY} element={<PrivacyPolicy />} />

    {/* Destination of the printed download QR code. No layout — it
        redirects to the Play Store / App Store within a frame or two. */}
    <Route path={ROUTES.APP_DOWNLOAD} element={<AppRedirect />} />

    {/* Portals (full-bleed, own shell) */}
    <Route path={ROUTES.MED_DASHBOARD} element={<MedicalDashboard />} />
    <Route path={ROUTES.LAB_DASHBOARD} element={<LabDashboard />} />
    <Route path={ROUTES.CORP_DASHBOARD} element={<CorporateDashboard />} />
    <Route path={ROUTES.QA_PORTAL} element={<QAPortal />} />
    <Route path={ROUTES.ADMIN} element={<AdminPortal />} />
    <Route path={ROUTES.SITE_ADMIN} element={<SiteAdmin />} />

    {/* Fallback */}
    <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
  </Routes>
  );
};

export default AppRoutes;
